import { createFileRoute } from "@tanstack/react-router";
import { AppLayout } from "@/components/layouts/AppLayout";
import { AdminMyAccessPage } from "@/components/pages/AdminMyAccessPage";

export const Route = createFileRoute("/admin/my-access")({
  component: AdminMyAccess,
});

function AdminMyAccess() {
  return (
    <AppLayout>
      <AdminMyAccessPage />
    </AppLayout>
  );
}
